import type {AssetUploadProgress} from '../assets/assets';

type OnUploadProgress = (options: AssetUploadProgress) => void;

function promiseWithResolvers<T>(): {promise: Promise<T>; resolve: (value: T) => void; reject: (reason?: unknown) => void} {
	let resolve!: (value: T) => void;
	let reject!: (reason?: unknown) => void;
	const promise = new Promise<T>((res, rej) => {
		resolve = res;
		reject = rej;
	});
	return {promise, resolve, reject};
}

export const uploadWithProgress = ({
	file,
	url,
	onProgress,
}: {
	file: Blob;
	url: string;
	onProgress: OnUploadProgress;
}) => {
	const xhr = new XMLHttpRequest();

	xhr.open('PUT', url);

	xhr.upload.onprogress = function (event) {
		if (event.lengthComputable) {
			onProgress({
				progress: event.loaded / event.total,
				loadedBytes: event.loaded,
				totalBytes: event.total,
			});
		}
	};

	const {resolve, reject, promise} = promiseWithResolvers<void>();

	xhr.onload = function () {
		if (xhr.status === 200) {
			resolve();
		} else {
			reject(new Error(`Upload failed with status: ${xhr.status}`));
		}
	};

	xhr.onerror = function () {
		reject(new Error('Failed to upload'));
	};

	xhr.setRequestHeader('Content-Type', file.type);
	xhr.setRequestHeader('Cache-Control', 'public, max-age=31536000');
	xhr.send(file);

	return promise;
};
